module.exports = __webpack_public_path__ + "static/img/correct_box.00b36e81.png";